const iptaliade = () => {
  return (
    <div className="mss">
      <h2>MOBİL ASSISTANCE SERVİS HİZMETLERİ DENETİM DANIŞMANLIK TİCARET LTD. ŞTİ.</h2>
      <h2>ONLİNE ÇEKİCİ VE ACİL YOL YARDIM HİZMETLERİ İPTAL, İADE VE OPERASYON KOŞULLARI</h2>

      <h2>MADDE 1 – HİZMETİN NİTELİĞİ VE CAYMA HAKKI İSTİSNASI</h2>
      <p>
        1.1. Platform üzerinden talep edilen oto çekici, kurtarma ve acil yol yardım hizmetleri;
        Tüketici&apos;nin anlık çağrısı ve onayı doğrultusunda, derhal ifasına başlanan, belirlenen
        lokasyona ve zamana özgü acil nitelikteki ifa hizmetleridir.
      </p>
      <p>
        1.2. 6502 sayılı Kanun ve Mesafeli Sözleşmeler Yönetmeliği’nin 15. maddesinin 1. fıkrasının
        (h) bendi uyarınca; &quot;Tüketicinin onayı ile ifasına başlanan hizmetler&quot; yasal cayma
        hakkının istisnası kapsamındadır. Bu doğrultuda, çekici operatörünün yönlendirilmesi ve
        operasyonun başlatılması ile birlikte genel cayma hakkı kullanılamaz; iptal ve iade
        süreçlerinde işbu belgede düzenlenen kademeli operasyonel kurallar tatbik edilir.
      </p>

      <h2>MADDE 2 – KADEMELİ İPTAL KOŞULLARI VE BOŞ ÇEKİŞ KESİNTİLERİ</h2>
      <p>
        Tüketici tarafından iletilen iptal taleplerinde, çekici ve operasyonun anlık durumuna göre
        aşağıdaki şartlar uygulanır:
      </p>
      <ul>
        <li>
          a. Çekici Yola Çıkmadan Önce Yapılan İptaller: Hizmet sağlayıcı çekici/kurtarıcı operatörü
          henüz hareket etmemiş, göreve başlamamış ve sisteme &quot;Yola Çıktı&quot; bildirimi
          düşmemiş ise iptal talebi ücretsiz ve kesintisiz olarak kabul edilir; tahsil edilen hizmet
          bedelinin %100&apos;ü Tüketici’ye iade edilir.
        </li>
        <li>
          b. Çekici Yola Çıktıktan Sonra Yapılan İptaller (Boş Çekiş / Operasyon Maliyeti Kesintisi):
          Çekici operatörü Tüketici&apos;nin bildirdiği lokasyona doğru harekete geçtikten sonra
          Tüketici tarafından iptal talebinde bulunulması halinde; fiilen sarf edilen yol, zaman, iş
          gücü ve akaryakıt maliyetini karşılamak amacıyla hizmet bedelinden asgari 1.500 TL taban
          ücret veya toplam hizmet bedelinin %40&apos;ı (hangisi yüksek ise) &quot;Boş Çekiş ve
          Operasyon Bedeli&quot; olarak mahsup edilir; kalan bakiye Tüketici’ye iade edilir.
        </li>
        <li>
          c. Çekici Olay Yerine Ulaştıktan Sonra Yapılan İptaller: Çekici operatörünün Tüketici
          tarafından bildirilen kaza/arıza lokasyonuna ulaşmasından sonra yapılacak iptallerde veya
          hizmet almaktan vazgeçilmesi durumunda; hizmet fiilen ifa edilmiş sayılır, hizmet bedelinin
          %100&apos;ü tahakkuk eder ve hiçbir ücret iadesi yapılmaz.
        </li>
        <li>
          d. Mücbir Sebepler Nedeniyle İptaller: Doğal afetler, yol kapanması, olağanüstü hava
          şartları veya yetkili kolluk kuvvetlerinin müdahalesi gibi mücbir sebepler dolayısıyla
          hizmetin ifa edilememesi halinde iptal işlemi ücretsiz uygulanır ve bedelin tamamı iade
          edilir.
        </li>
      </ul>

      <h2>MADDE 3 – TÜKETİCİ KAYNAKLI İMKÂNSIZLIK VE TEMERRÜT HALLERİ</h2>
      <p>
        Aşağıda sayılan haller hukuken &quot;Çekicinin Olay Yerine Ulaşmasından Sonra Yapılan
        İptal&quot; hükmünde kabul edilir; hizmet bedelinin tamamı tahakkuk eder ve herhangi bir ücret
        iadesi yapılmaz:
      </p>
      <ul>
        <li>
          a. Tüketici’nin yanlış, eksik veya gerçeğe aykırı adres/konum bildirmesi sebebiyle araca
          ulaşılamaması,
        </li>
        <li>
          b. Çekici operatörü olay yerine vardığında Tüketici’ye telefon veya diğer iletişim
          kanallarıyla makul süre (en az 15 dakika) ulaşılamaması veya Tüketici&apos;nin haklı bir
          mazeret olmaksızın olay yerinde bulunmaması,
        </li>
        <li>
          c. Çekici operatörü yoldayken veya olay yerine vardığında Tüketici&apos;nin Mobil
          Assistance&apos;a haber vermeksizin üçüncü kişilere ait başka bir çekici ile anlaşıp olay
          yerinden ayrılmış olması,
        </li>
        <li>
          d. Tüketici tarafından aracın cinsi, tonajı veya yürür durumu (örneğin tekerlek kilitlenmesi,
          dingil kopması, şanzıman arızası, yüklü ticari araç olması vb.) hakkında eksik veya hatalı
          bilgi verilmesi sebebiyle yönlendirilen çekicinin aracı teknik olarak çekememesi ve
          çekicinin boş dönmek zorunda kalması.
        </li>
      </ul>

      <h2>MADDE 4 – OLAY YERİNDE BEKLEME (DEMURRAGE) BEDELİ</h2>
      <p>
        4.1. Çekici operatörü Tüketici tarafından bildirilen konuma ulaştıktan sonra, Tüketici&apos;den
        kaynaklanan nedenlerle (araç anahtarı veya ruhsat arama, resmi trafik kaza tespit tutanağının
        tamamlanmasını bekleme, araç içi yükün boşaltılması vb.) çekicinin olay yerinde bekletilmesi
        esastır.
      </p>
      <p>
        4.2. İlk 15 (on beş) dakikayı aşan beklemelerde; çekici operatörünün uğradığı zaman ve iş
        kaybını karşılamak üzere, ilk 15 dakikadan sonraki her 15 dakika için 250 TL (KDV dahil) ek
        bekleme bedeli tahakkuk eder. Tüketici bu ek bedeli olay yerinde veya Mobil Assistance
        sistemleri üzerinden ödemekle yükümlüdür.
      </p>

      <h2>MADDE 5 – HİZMET SAĞLAYICI KAYNAKLI İPTAL VE İADE KOŞULLARI</h2>
      <p>
        5.1. Hizmetin, Mobil Assistance&apos;ın veya anlaşmalı çekici operatörünün kusurundan
        kaynaklı olarak makul süreler içerisinde hiç ifa edilememesi halinde, Tüketici tarafından
        ödenen tutarın tamamı herhangi bir kesinti yapılmaksızın iade edilir.
      </p>
      <p>
        5.2. Hizmetin kısmen ifa edilmesi (örneğin yalnızca olay yerinde arıza desteği verilip çekim
        yapılamaması gibi) durumunda, ifa edilmeyen kısma karşılık gelen tutar oranlanarak
        Tüketici&apos;ye iade edilir.
      </p>
      <p>
        5.3. Hatalı veya mükerrer tahsilat yapıldığının tespit edilmesi halinde, fazla tahsil edilen
        tutar derhal ve kesintisiz olarak iade edilir.
      </p>

      <h2>MADDE 6 – İADE SÜRESİ VE YÖNTEMİ</h2>
      <p>
        6.1. Onaylanan iade tutarları, Tüketici&apos;nin ödeme yaptığı kanal (kredi kartı, banka kartı
        veya havale/EFT) üzerinden doğrudan ödemenin tahsil edildiği karta/hesaba gerçekleştirilir.
      </p>
      <p>
        6.2. İade işlemi, talebin onaylandığı tarihten itibaren en geç 14 (on dört) iş günü içerisinde
        tamamlanarak ilgili bankaya iletilir. İade tutarının banka tarafından Tüketici&apos;nin hesap
        ekstresine yansıtılma süresi ilgili bankanın kart prosedürlerine bağlıdır.
      </p>

      <h2>MADDE 7 – TAŞIMA ESNASINDAKİ HASARLAR VE TAZMİNAT</h2>
      <p>
        Aracın çekici üzerine yüklenmesi, bağlanması ve taşınması esnasında çekici operatörünün
        kusuruna dayalı olarak araca gelebilecek maddi zararlardan; Türk Ticaret Kanunu’nun taşıma
        hükümleri ve zorunlu taşıyıcı sorumluluk sigortası kapsamında doğrudan fiili taşımayı
        gerçekleştiren çekici operatörü sorumludur. Bu kapsamdaki hasar talepleri bağımsız bir hasar
        tespit süreci olarak yürütülür; Mobil Assistance taraflar arasındaki iletişim ve sigorta
        dosya koordinasyonunu sağlar.
      </p>

      <h2>MADDE 8 – İPTAL VE İADE TALEBİNİN YAPILMASI</h2>
      <p>
        Tüketici, iptal ve iade taleplerini Platform üzerindeki canlı destek kanalları,
        info@mobilassistance.com e-posta adresi veya 7/24 hizmet veren 0850 255 02 03 numaralı çağrı
        merkezimiz üzerinden sipariş/talep numarasını ve gerekçesini belirterek iletmelidir.
      </p>
      <p>
        İşbu Koşullar, Mesafeli Satış Sözleşmesi&apos;nin ayrılmaz bir parçası olup, hizmet siparişi
        oluşturulduğu ve ödeme yapıldığı anda Tüketici tarafından kabul edilmiş sayılır.
      </p>
    </div>
  )
}

export default iptaliade
